import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-setting",
  "use": "icon-cms-setting-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-setting\"><path d=\"M155.23,186.14H68.47L25.08,111,68.47,35.86h86.76L198.62,111Zm-81.57-9H150L188.22,111,150,44.86H73.66L35.48,111Z\" /><path d=\"M126.36,136.14h-29L82.83,111,97.34,85.87h29L140.88,111Zm-23.83-9h18.64L130.48,111l-9.31-16.13H102.53L93.22,111Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol